import type { ProblemCopy } from '../../api/problem.ts';

/**
 * German's own sentence frames — the sibling of `en/shared.ts`, and deliberately not shared with it.
 *
 * The frame is the part that does not survive translation, so each language writes its own. What crosses
 * the boundary is the `Strings` type, and these builders return values inside it.
 */

/** "Diese Playlist konnte nicht gelesen werden. Die Instanz hat etwas zurückgeschickt, …" */
export function unreadable(title: string): ProblemCopy {
  return {
    title,
    detail:
      'Die Instanz hat etwas zurückgeschickt, das Visious nicht lesen kann. Deshalb gibt es hier nichts zu zeigen.',
    retryable: false,
  };
}
